/**
 * ACIL Intelligence - API Client
 * Axios instance configured for ACIL Intelligence backend.
 */
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export function formatApiError(detail) {
  if (detail == null) return 'Ocurrio un error. Intenta de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail === 'object') {
    if (typeof detail.msg === 'string') return detail.msg;
    return JSON.stringify(detail);
  }
  return String(detail);
}

/** Extrae y formatea el error de un objeto axios error en un string seguro para React. */
export function extractApiError(err, fallback = 'Ocurrio un error. Intenta de nuevo.') {
  const detail = err?.response?.data?.detail;
  if (detail !== undefined && detail !== null) return formatApiError(detail);
  if (err?.message) return err.message;
  return fallback;
}

export default api;
